declare const c: {
  mailcheck: (value: string) => boolean;
  emailRegExp: RegExp;
};

export const emailRegExp = c.emailRegExp;

export const validateEmail = (email: string): boolean => emailRegExp.test(String(email));

export function mailCheckRun(value: string): boolean {
  return c.mailcheck(value);
}
